


import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Spinner } from '@uplift/ui';

const useStyles = makeStyles()(() => ({
  container: {
    height: '100vh',
    display: 'flex',
  },
  fixed: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
  },
  spinnerWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignIteems: 'center',
    justifyContent: 'center',
  }
}));

export const Loading: React.FC<{
  fixed?: boolean;
}> = ({ children, fixed = false }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.container, fixed ? classes.fixed : false)}>
      {children}
      <div className={classes.spinnerWrapper}>
        <Spinner/>
      </div>
    </div>
  );
};
